import ModelType from '../../Model/ModelType';
import { Aggregation, TimeBucket } from '../../../services/constants';
import T from '../../../localization/LocalizationKeys';
import { AggregateModel, IntervalModel } from '../../Model/Models';
import SignalFunction from './util/SignalFunction';
import NodeDataSource from './NodeDataSource';
import _ from 'lodash';

export const getModels = () => {
};


const SignalDataSource =
  ({
    nodes,
    signals = [],
    timeRange = null,
    aggregate = Aggregation.MEAN,
    interval = TimeBucket.PT1H,
    reloadTrigger,
    dashboardDate,
    showPath
  }) => {
    return SignalFunction({
      nodes,
      signals,
      timeRange,
      aggregate,
      interval,
      reloadTrigger,
      dashboardDate,
      showPath
    });
  };

SignalDataSource.models = [
  ...NodeDataSource.models,
  {
    path: 'signals',
    type: ModelType.SIGNALS,
    label: T.common.signals
  },
  AggregateModel,
  IntervalModel,
  {
    path: 'timeRange',
    type: ModelType.TIME_RANGE,
    label: T.common.input.timerange.title
  },
  {
    path: 'showPath',
    type: ModelType.SWITCH,
    label: T.dashboard.editor.inputs.showpath
  }
];

SignalDataSource.getUsedSystemModels = (data) => {
  return _.reduce(data.signals, (result, signal) => [...result, signal.modelId], []);
};

SignalDataSource.getUsedAssets = (data) => {
  return NodeDataSource.getUsedAssets(data);
};

export default SignalDataSource;
